export default __webpack_public_path__ + "static/media/Form_adjustment_upload_template.20de1576.xlsx";